import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import Swal from "sweetalert2";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/Api/ApiServices";

const EvaluatorTable = () => {
  const EvaluatorInfoRow = useSelector(
    (state) => state.EvaluatorInfo?.EvaluatorInfoRow
  );

  const [EV_NT_EvaluatorInfoId, setEV_NT_EvaluatorInfoId] = useState(null);
  const state = useSelector((state) => {
    return {
      EvaluatorInfoRow: state.EvaluatorInfo.AddEvaluatorInfoRow,
    };
  });
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "userFullName",
      ShowStatus: true,
      NmaeColumn: "اسم المحكم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "userFullName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "email",
      ShowStatus: true,
      NmaeColumn: "البريد الالكتروني",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "email",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "fieldName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "roundName",
      ShowStatus: true,
      NmaeColumn: "الدورة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "roundName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        Swal.fire({
          title: "هل انت متأكد من حذف المحكم",
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/EvaluatorInfo/DeleteEvaluatorInfo",
              {
                eV_NT_EvaluatorInfoId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [state.EvaluatorInfoRow]);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"eV_NT_EvaluatorInfoId"}
        valueButtonAction={"eV_NT_EvaluatorInfoId"}
        URL={`api/EvaluatorInfo/GetEvaluatorInfoByUserId`}
        UrlBody={{
          // roundYearId: props.roundActive,
          uS_UserGuid: EvaluatorInfoRow?.userGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};
export default EvaluatorTable;
